import React from 'react';
import { Gift, Clock, MessageCircle, FileSignature } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Bono 1 — Kit "Consultorio PRO en 30 Min"',
  description: 'Todo listo en tu consultorio en 30 minutos.',
  icon: <Clock className="w-5 h-5 text-amber-600" data-id="element-12" />,
  items: ['Cronograma paso a paso', 'Carpetas digitales listas para copiar', 'Plan de impresión inteligente', 'Checklist de 20 puntos']
}, {
  id: 2,
  title: 'Bono 2 — Scripts de WhatsApp PRO',
  description: '25 mensajes listos que reducen ausencias.',
  icon: <MessageCircle className="w-5 h-5 text-amber-600" data-id="element-13" />,
  items: ['Confirmación de turno automática', 'Cuidados post sesión por patología', 'Seguimiento y reactivación de pacientes', 'Scripts para pie diabético']
}, {
  id: 3,
  title: 'Bono 3 — Informe de Derivación Médica PRO',
  description: 'Derivá al médico en menos de 3 minutos.',
  icon: <FileSignature className="w-5 h-5 text-amber-600" data-id="element-14" />,
  items: ['9 plantillas de informe listas', 'Frases clínicas predefinidas', 'Tabla de derivación por hallazgo', 'Checklist de verificación pre-envío']
}];
export function BonusesSection() {
  return <section className="py-14 bg-slate-900 text-white relative overflow-hidden" data-id="element-15">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-16">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500 rounded-full blur-3xl" data-id="element-17"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#0D7377] rounded-full blur-3xl" data-id="element-18"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-19">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-20">
          <div className="inline-flex items-center justify-center gap-2 bg-amber-500/20 text-amber-400 px-3 py-1.5 rounded-full font-bold mb-4 border border-amber-500/30 text-sm" data-id="element-21">
            <Gift className="w-4 h-4" data-id="element-22" />
            <span data-id="element-23">Gratis por el día de hoy</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-3" data-id="element-24">
            🎁 Bonos Exclusivos
          </h2>
          <p className="text-base text-slate-300" data-id="element-25">
            Herramientas premium sin costo adicional al adquirir tu Sistema PRO
            hoy.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-26">
          {bonuses.map(bono => <div key={bono.id} className="bg-slate-800/50 border border-slate-700 rounded-xl p-4 backdrop-blur-sm" data-id="element-27">
              <div className="flex items-center gap-3 mb-2" data-id="element-28">
                <div className="bg-amber-500/20 p-2 rounded-lg flex-shrink-0" data-id="element-29">
                  {bono.icon}
                </div>
                <h3 className="text-base font-bold text-white leading-tight" data-id="element-30">
                  {bono.title}
                </h3>
              </div>
              <p className="text-slate-400 text-sm mb-3" data-id="element-31">{bono.description}</p>
              <ul className="space-y-1.5" data-id="element-32">
                {bono.items.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-33">
                    <svg className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-34">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-35" />
                    </svg>
                    <span className="text-slate-400 text-xs leading-snug" data-id="element-36">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl px-6 py-4 text-center max-w-xl mx-auto shadow-lg" data-id="element-37">
          <p className="text-sm font-bold text-white mb-0.5" data-id="element-38">
            Valor total de los 3 bonos:{' '}
            <span className="line-through opacity-75" data-id="element-39">$89.000 ARS</span>
          </p>
          <p className="text-xl font-black text-white" data-id="element-40">
            Por el día de hoy → GRATIS ✅
          </p>
        </div>
      </div>
    </section>;
}